<app-online-store-form-wrapper
  data-testid="online-store-view-container"
  [config]="config"
  [editMode]="false"
  [viewMode]="true"
  [canUpdate]="canUpdate()"
></app-online-store-form-wrapper>